import shuffle from 'lodash/shuffle'

const NameGenerator = (sourceNames = []) => () => shuffle(sourceNames)[0]

export default NameGenerator
